import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class AllPermissionsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'permissions': [
                    'CURRENT_ACCOUNT_PERMISSION',
                    'PURCHASE_ORDER_PERMISSION',
                    'ORDER_PERMISSION',
                    'USER_PERMISSION',
                    'CREATE_USER_PERMISSION',
                    'SUPPORT_PERMISSION',
                ]
            },
            errors: []
        }
    }

    permissions() {
        return this.content().permissions
    }
}